export enum TransferStatus {
    Warning = 'warning',
    Error = 'error'
  }